import React from 'react';
import './infoBar.css'
import { IoFlower } from "react-icons/io5";

const InfoBar = () => {
  return (
    <div className="info-bar">
      <div className="info-item">
        <div className="icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 3h15v13H1z"/>
            <path d="M16 8h4l3 3v5h-7V8z"/>
            <circle cx="5.5" cy="18.5" r="2.5"/>
            <circle cx="18.5" cy="18.5" r="2.5"/>
          </svg>
        </div>
        <p>Delivery <span className="highlight">6 days</span> a week & on the <span className="highlight">same day</span></p>
      </div>
      
      <div className="info-item">
        <div className="icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
        <p><span className="highlight">Premium quality</span> flowers & arrangements</p>
      </div>
      
        <div className="info-item">
          <div className="icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2C8.5 2 6 4.5 6 8c0 2.5 1.5 4.5 3 6l3 3 3-3c1.5-1.5 3-3.5 3-6 0-3.5-2.5-6-6-6z"/>
              <path d="M12 8v8"/>
              <path d="M8 12h8"/>
            </svg>
          </div>
          <p><span className="highlight">7 days fresh guarantee</span></p>
        </div>
      
      <div className="info-item">
        <div className="icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            <circle cx="9" cy="9" r="1"/>
            <circle cx="15" cy="9" r="1"/>
            <path d="M9 13h6"/>
          </svg>
        </div>
        <p>We score an <span className="highlight">8.8/10</span> with our customers</p>
      </div>
    </div>
  );
};

export default InfoBar;